import { styled } from '@mui/material/styles';
import { useDrawingArea } from '@mui/x-charts/hooks';
import type { ReactNode } from 'react';

const StyledCenterLabel = styled('text')(({ theme }) => ({
  dominantBaseline: 'central',
  fill: theme.palette.text.secondary,
  fontFamily: theme.typography.fontFamily,
  fontWeight: theme.typography.fontWeightRegular,
  letterSpacing: 0.15,
  lineHeight: 32,
  textAnchor: 'middle',
}));

type TransactionTypeBreakdownCenterLabelProps = {
  children: ReactNode;
  innerRadius: number;
};

export function TransactionTypeBreakdownCenterLabel(
  props: TransactionTypeBreakdownCenterLabelProps,
) {
  const { children, innerRadius } = props;
  const { height, left, top, width } = useDrawingArea();

  const text = String(children);
  const maxWidth = innerRadius * Math.SQRT2;
  // 0.65 ≈ average char-width / font-size ratio for the price format
  const fontSize = Math.max(12, Math.min(20, maxWidth / (text.length * 0.65)));

  return (
    <StyledCenterLabel
      sx={{ fontSize: `${fontSize}px` }}
      x={left + width / 2}
      y={top + height / 2}
    >
      {children}
    </StyledCenterLabel>
  );
}
